import buildProductDetailModal from "@/js/modules/buildProductDetailModal";
import scrollSnapSlider from "@/js/modules/scrollSnapSlider";

export default function (){
    buildProductDetailModal()
    scrollSnapSlider()
}
